import { render } from "./pageHistory.vue?vue&type=template&id=01e0b380&scoped=true"
import script from "./pageHistory.vue?vue&type=script&lang=js"
export * from "./pageHistory.vue?vue&type=script&lang=js"

import "./pageHistory.vue?vue&type=style&index=0&id=01e0b380&scoped=true&lang=css"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e0b380"]])

export default __exports__